<template>
  <div class="PageMyReleaseOrderAuthMobile">
    <div class="warpper">
      <div class="page-form">
        <h2 class="page-title">{{ $t("pages.wording.myReleaseOrderAuth") }}</h2>
        <el-form ref="form" label-position="top">
          <el-form-item>
            <el-input
              v-model="searchForm.releaseNo"
              :placeholder="$t('pages.wording.placeHolderReleaseNo')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.reserveFactory"
              :placeholder="$t('pages.wording.placeholderFactory')"
              clearable
            >
              <el-option v-for="item in selection.factory" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.reserveDate"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('pages.wording.placeHolderSalesDate')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="button-primary" type="primary" @click="search()">{{
              $t("pages.button.search")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <Tabs :tabsData.sync="approvalSummaryData" :active="activeTab" id="mobileTab">
      <div slot="first">
        <div class="grid-card">
          <CardOrder
            v-for="data in pendingApprovalReleaseList"
            :key="data.releaseOrderNo"
            @cardClick="goToApprovalFormPage(data)"
          >
            <div slot="cardHeader" class="card-header">
              <div class="value">{{ data.vendor }}</div>
              <label>{{ $t("release.status." + data.releaseOrderStatus) }}</label>
            </div>
            <div slot="cardBody" class="card-body">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.releaseNumber") }}</div>
                <div class="value value-highlight">{{ data.releaseOrderNo }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveNo") }}</div>
                <div class="value">{{ data.reserveNo }}</div>
              </div>
            </div>
            <div slot="cardFooter" class="card-footer">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.carPlat") }}</div>
                <div class="value value-highlight">{{ data.tempCar ? data.tmpCarPlat : data.carPlat }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveFactory") }}</div>
                <div class="value">{{ data.reserveFactory }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.salesDate") }}</div>
                <div class="value">{{ formateDatetimeStr("Date", data.reserveArriveDatetime) }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.applicatorName") }}</div>
                <div class="value">{{ data.applicatorName }}</div>
              </div>
            </div>
          </CardOrder>
        </div>
      </div>
      <div slot="second">
        <div class="grid-card">
          <CardOrder
            v-for="data in inProcessApprovalReleaseList"
            @cardClick="goToApprovalFormPage(data)"
            :key="data.releaseOrderNo"
          >
            <div slot="cardHeader" class="card-header">
              <div class="value">{{ data.vendor }}</div>
              <label>{{ $t("release.status." + data.releaseOrderStatus) }}</label>
            </div>
            <div slot="cardBody" class="card-body">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.releaseNumber") }}</div>
                <div class="value value-highlight">{{ data.releaseOrderNo }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveNo") }}</div>
                <div class="value">{{ data.reserveNo }}</div>
              </div>
            </div>
            <div slot="cardFooter" class="card-footer">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.carPlat") }}</div>
                <div class="value value-highlight">{{ data.tempCar ? data.tmpCarPlat : data.carPlat }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveFactory") }}</div>
                <div class="value">{{ data.reserveFactory }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.salesDate") }}</div>
                <div class="value">{{ formateDatetimeStr("Date", data.reserveArriveDatetime) }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.applicatorName") }}</div>
                <div class="value">{{ data.applicatorName }}</div>
              </div>
            </div>
          </CardOrder>
        </div>
      </div>
      <div slot="third">
        <div class="grid-card">
          <CardOrder
            v-for="data in doneApprovalReleaseList"
            @cardClick="goToApprovalFormPage(data)"
            :key="data.releaseOrderNo"
          >
            <div slot="cardHeader" class="card-header">
              <div class="value">{{ data.vendor }}</div>
              <label>{{ $t("release.status." + data.releaseOrderStatus) }}</label>
            </div>
            <div slot="cardBody" class="card-body">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.releaseNumber") }}</div>
                <div class="value value-highlight">{{ data.releaseOrderNo }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveNo") }}</div>
                <div class="value">{{ data.reserveNo }}</div>
              </div>
            </div>
            <div slot="cardFooter" class="card-footer">
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.carPlat") }}</div>
                <div class="value value-highlight">{{ data.tempCar ? data.tmpCarPlat : data.carPlat }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.reserveFactory") }}</div>
                <div class="value">{{ data.reserveFactory }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.salesDate") }}</div>
                <div class="value">{{ formateDatetimeStr("Date", data.reserveArriveDatetime) }}</div>
              </div>
              <div class="card-item">
                <div class="label">{{ $t("pages.wording.applicatorName") }}</div>
                <div class="value">{{ data.applicatorName }}</div>
              </div>
            </div>
          </CardOrder>
        </div>
      </div>
    </Tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import CardOrder from "@/components/common/CardOrder.vue"
import Tabs from "@/components/common/Tabs.vue"
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"

export default {
  name: "PageMyApprovalReleaseMobile",
  components: {
    CardOrder,
    Tabs,
  },
  data() {
    return {
      selection: {
        factory: [],
      },
      searchForm: {
        releaseNo: null,
        reserveFactory: null,
        reserveDate: null,
      },
      approvalSummaryData: [
        {
          name: "first",
          label: this.$t("pages.wording.preProccess"),
          counts: 0,
        },
        {
          name: "second",
          label: this.$t("pages.wording.inProccess"),
          counts: 0,
        },
        {
          name: "third",
          label: this.$t("pages.wording.finish"),
          counts: 0,
        },
      ],
      pendingApprovalReleaseList: null,
      inProcessApprovalReleaseList: null,
      doneApprovalReleaseList: null,
      activeTab: "first",
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.search()
  },
  methods: {
    ...mapGetters(["getUserProfile"]),
    init() {
      this.searchForm.reserveDate = utils.parseDateToDateFormat(new Date())
      this.getFactorySelection()
      if (window.sessionStorage.getItem("mobileQueryParams") !== null) {
        let queryParams = JSON.parse(window.sessionStorage.getItem("mobileQueryParams"))
        this.searchForm.releaseNo = queryParams.releaseNo
        this.searchForm.reserveFactory = queryParams.reserveFactory
        this.searchForm.reserveDate = queryParams.reserveDate
        window.sessionStorage.removeItem("mobileQueryParams")
      }
    },
    search() {
      let vueInstance = this
      let queryIsLoading = vueInstance.$loading({
        fullscreen: false,
        target: document.querySelector("#mobileTab"),
      })
      let params = {
        releaseNo: vueInstance.searchForm.releaseNo,
        reserveArea: vueInstance.getUserProfile().area,
        reserveFactory: vueInstance.searchForm.reserveFactory,
        reserveArriveDate: vueInstance.searchForm.reserveDate,
      }
      api
        .apiGetApprovalReleaseTableForMobile(params)
        .then((response) => {
          let data = response.data
          if (data.success) {
            vueInstance.pendingApprovalReleaseList = data.result.pendingApprovalReleaseList
            vueInstance.inProcessApprovalReleaseList = data.result.inProcessApprovalReleaseList
            vueInstance.doneApprovalReleaseList = data.result.doneApprovalReleaseList
            vueInstance.approvalSummaryData[0].counts = (vueInstance.pendingApprovalReleaseList ?? []).length
            vueInstance.approvalSummaryData[1].counts = (vueInstance.inProcessApprovalReleaseList ?? []).length
            vueInstance.approvalSummaryData[2].counts = (vueInstance.doneApprovalReleaseList ?? []).length
          } else {
            vueInstance.pendingApprovalReleaseList = null
            vueInstance.inProcessApprovalReleaseList = null
            vueInstance.doneApprovalReleaseList = null
          }
          queryIsLoading.close()
        })
        .catch((error) => {
          console.log(error)
          queryIsLoading.close()
        })
    },
    getFactorySelection() {
      let vueInstance = this
      vueInstance.selection.factory = []
      let userRegion = utils.getFirstOrDefault(vueInstance.getUserProfile().region)
      let userArea = vueInstance.getUserProfile().area
      if (userArea !== null && userArea.length > 1) {
        userArea.forEach(function (area) {
          let params = {
            region: userRegion,
            area: area,
            factory: vueInstance.getUserProfile().factory,
          }
          api
            .apiGetFactory(params)
            .then((response) => {
              vueInstance.selection.factory.push(...response.data)
            })
            .catch((error) => {
              console.log(error)
            })
        })
      } else {
        let params = {
          region: userRegion,
          area: utils.getFirstOrDefault(userArea),
          factory: vueInstance.getUserProfile().factory,
        }
        api
          .apiGetFactory(params)
          .then((response) => {
            vueInstance.selection.factory = response.data
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    goToApprovalFormPage(data) {
      let prevPageParams = {
        routeName: "PageMyApprovalRelease",
        compName: "PageMyApprovalRelease_Mobile",
        key: {},
      }
      let queryparams = {
        releaseNo: this.searchForm.releaseNo,
        reserveFactory: this.searchForm.reserveFactory,
        reserveDate: this.searchForm.reserveDate,
      }
      window.sessionStorage.setItem("tempMobileQueryParams", JSON.stringify(queryparams))
      window.sessionStorage.setItem("prevPageParams", JSON.stringify(prevPageParams))
      this.$router.push({
        name: "PageMyApprovalReleaseForm",
        params: { releaseID: data.releaseID },
      })
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
}
</script>

<style scoped>
.PageMyReleaseOrderAuthMobile {
  margin: 0 -16px;
}

.el-form {
  margin-bottom: 16px;
}

.el-form .el-form-item {
  margin-bottom: 8px;
}

.el-form .el-form-item .el-input,
.el-form .el-form-item .el-button {
  width: 100%;
}

@media (min-width: 768px) {
  .Tabs {
    margin: 0 16px;
  }
}
</style>
